import { TrackingEvent } from "./TrackingEvent";
const createTrackingEvent = (eventName, additionalData) => {
    return new TrackingEvent(eventName, {
        detail: {
            additionalData,
        },
    });
};
export function dispatchTrackingEvent(eventName, additionalData) {
    const event = createTrackingEvent(eventName, additionalData);
    if (typeof document === "undefined") {
        return Promise.resolve();
    }
    document.dispatchEvent(event);
    return new Promise((resolve) => setTimeout(resolve, 500));
}
//# sourceMappingURL=trackingEvents.js.map